import React, { useState, useEffect, useMemo } from "react";
import SweetAlert from "react-bootstrap-sweetalert";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import redirectURL from "./redirectURL";
import "../assets/css/inventorymanagement.css";
import { RiDeleteBin5Line } from "react-icons/ri";
import { IoMdAdd } from "react-icons/io";

const WholesaleMaster = () => {
    const [loadshow, setLoadshow] = useState("show-n");
    const [overlayBlock, setOverlayBlock] = useState("show-n");
    const [overlyBlock, setOverlyBlock] = useState("show-n");
    const [showDeletePopup, setShowDeletePopup] = useState(false);
    const [selectedRow, setSelectedRow] = useState(null);

    const [show, setShow] = useState(false);
    const [basicTitle, setBasicTitle] = useState("");
    const [basicType, setBasicType] = useState("default");

    const [isSliderOpen, setIsSliderOpen] = useState(false);
    const [sliderType, setSliderType] = useState(null); // 1 = Add, 2 = Edit
    const [sliderCl, setSliderCl] = useState("slider-25");
    const [sliderTitle, setSliderTitle] = useState("");

    const [rowData, setRowData] = useState([]);
    const [columnWithDefs, setColumnWithDefs] = useState([]);
    
    const [editFormData, setEditFormData] = useState({
        id: "",
        given_month: "",
        wholesale_date: "",
    });

    const [duplicatedEditData, setDuplicatedEditData] = useState({
        id: "",
        given_month: "",
        wholesale_date: "",
    });

    // Get current date in YYYY-MM format for the min attribute
    const currentMonth = useMemo(() => {
        const today = new Date();
        return `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, "0")}`;
    }, []);

    // Action column renderer for Edit button with same styling as DestinationMaster
    const actionCellRenderer = (params) => {
        return (
            <div style={{
                height: "36px", 
                padding: 0, 
                display: "flex", 
                justifyContent: "center", 
                alignItems: "center"
            }}>
                <button
                    title="Edit"
                    className="mt-2"
                    style={{
                        height: "30px", 
                        width: "60px",
                        padding: "0 10px",
                        border: "1px solid #93385D",
                        borderRadius: "4px",
                        cursor: "pointer",
                        backgroundColor: "#F4EBEF",
                        fontSize: "0.8rem",
                        color: "#93385D",
                    }}
                    onClick={() => handleEdit(params.data)}
                >
                    Edit
                </button>
            </div>
        );
    };

    const wholesaleCols = useMemo(() => [
        {
            headerName: "",
            field: "actions",
            sortable: false,
            filter: false,
            width: "90px",
            cellClass: "custom-cell", 
            cellRenderer: actionCellRenderer,
        },
        // Add this as the first column in wholesaleCols
{
    headerName: "",
    field: "delete",
    sortable: false,
    filter: false,
    width: "90px",
    cellClass: "custom-cell",
    cellRenderer: (params) => (
        <div
            style={{
                height: "36px",
                padding: 0,
                display: "flex",
                justifyContent: "center",
                alignItems: "center"
            }}
        >
            <button
                title="Delete"
                style={{
                    height: "30px",
                    width: "60px",
                    backgroundColor: "transparent",
                    border: "none",
                    borderRadius: "4px",
                    cursor: "pointer",
                }}
                onClick={() => handleDelete(params.data)}
            >
                <RiDeleteBin5Line
                    style={{ color: "red", fontSize: "20px" }}
                />
            </button>
        </div>
    ),
},
        {
            headerName: "Calendar Month",
            field: "given_month",
            width: 150,
            valueGetter: (p) => {
                if (!p.data?.given_month) return "";
                const d = new Date(p.data.given_month);
                return isNaN(d) ? p.data.given_month : `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}`;
            },
        },
        { headerName: "Calender Year", field: "year", width: 120 },
        { headerName: "Month No", field: "month", width: 120 },
        {
            headerName: "Wholesale Date",
            field: "wholesale_date",
            width: 160,
            valueGetter: (p) => {
                if (!p.data?.wholesale_date) return "";
                const d = new Date(p.data.wholesale_date);
                return isNaN(d) ? p.data.wholesale_date : d.toISOString().split("T")[0];
            },
        },
        { headerName: "Day of Week", field: "day", width: 140 },
        {
            headerName: "Inserted Date",
            field: "inserted_date",
            hide: true,
            valueGetter: (p) => {
                if (!p.data?.inserted_date) return "";
                const d = new Date(p.data.inserted_date);
                return isNaN(d) ? p.data.inserted_date : d.toISOString().split("T")[0];
            },
        },
    ], []);
const handleDelete = (row) => {
    setSelectedRow(row);
    setShowDeletePopup(true);
    setOverlayBlock("show-m");
};

const onClickingPopupDeleteBtn = async () => {
    setLoadshow("show-m");
    setOverlayBlock("show-m");

    const params = {
        wholesale_date: selectedRow.wholesale_date
    };

    try {
        const response = await redirectURL.post(
            "masters/deleteWholesaleDay",
            params
        );

        if (response.data.status === "success") {
            await getMainData();
            setShowDeletePopup(false);
            setShow(true);
            setBasicType("success");
            setBasicTitle("Wholesale Day Deleted Successfully");
        } else {
            setShow(true);
            setBasicType("info");
            setBasicTitle(
                response.data.message || "Failed to delete Wholesale Day"
            );
        }
    } catch (error) {
        setShow(true);
        setBasicType("info");
        setBasicTitle(
            error?.response?.data?.message ||
            "Failed to delete Wholesale Day"
        );
    } finally {
        setLoadshow("show-n");
        setOverlayBlock("show-n");
    }
};

const onClickDeletePopupCancelBtn = () => {
    setOverlayBlock("show-n");
    setShowDeletePopup(false);
};
    const defaultColDef = useMemo(() => ({
        sortable: true,
        filter: true,
        pivot: true,
        enableValue: true,
        enableRowGroup: true,
        resizable: true,
    }), []);

    const sideBar = useMemo(() => ({
        toolPanels: [
            { id: "columns", labelDefault: "Columns", labelKey: "columns", iconKey: "columns", toolPanel: "agColumnsToolPanel" },
            { id: "filters", labelDefault: "Filters", labelKey: "filters", iconKey: "filter", toolPanel: "agFiltersToolPanel" },
        ],
    }), []);

    const statusPanel = useMemo(() => ({
        statusPanels: [
            { statusPanel: "agTotalAndFilteredRowCountComponent", align: "left" },
            { statusPanel: "agTotalRowCountComponent", align: "center" },
            { statusPanel: "agFilteredRowCountComponent" },
            { statusPanel: "agSelectedRowCountComponent" },
            { statusPanel: "agAggregationComponent" },
        ],
    }), []);

    // Reset form data
    const resetFormData = () => {
        setEditFormData({ 
            id: "",
            given_month: "", 
            wholesale_date: "" 
        });
        setDuplicatedEditData({
            id: "",
            given_month: "", 
            wholesale_date: "" 
        });
    };

    const openSlider = () => {
        resetFormData();
        setIsSliderOpen(true);
        setSliderType(1);
        setSliderCl("slider-25");
        setOverlyBlock("show-m");
        setSliderTitle("Add New Wholesale Day");
    };

    const handleEdit = (row) => {
        setEditFormData({
            id: row._id || row.id,
            given_month: formatDateForMonthInput(row.given_month),
            wholesale_date: formatDateForDateInput(row.wholesale_date)
        });
        setDuplicatedEditData({
            id: row._id || row.id,
            given_month: formatDateForMonthInput(row.given_month),
            wholesale_date: formatDateForDateInput(row.wholesale_date)
        });
        setIsSliderOpen(true);
        setSliderType(2);
        setSliderCl("slider-25");
        setOverlyBlock("show-m");
        setSliderTitle("Edit Wholesale Day");
    };

    // Helper functions to format dates for input fields
    const formatDateForMonthInput = (dateString) => {
        if (!dateString) return "";
        const d = new Date(dateString);
        return isNaN(d) ? "" : `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}`;
    };

    const formatDateForDateInput = (dateString) => {
        if (!dateString) return "";
        const d = new Date(dateString);
        return isNaN(d) ? "" : d.toISOString().split("T")[0];
    };

    const closeSlider = () => {
        setIsSliderOpen(false);
        setSliderType(null);
        setOverlayBlock("show-n");
        setOverlyBlock("show-n");
        resetFormData();
    };

    const onClickingSliderCloseIcon = () => {
        setOverlyBlock("show-n");
        setIsSliderOpen(false);
        resetFormData();
    };

    const hideOverlySlideBlock = () => {
        setIsSliderOpen(false);
        setLoadshow("show-n");
        setOverlyBlock("show-n");
        resetFormData();
    };

    const closeAlert = () => {
        setShow(false);
        setIsSliderOpen(false);
        setLoadshow("show-n");
        setOverlayBlock("show-n");
        setOverlyBlock("show-n");
    };

    // Month bounds calculation
    const monthBounds = useMemo(() => {
        const ym = editFormData.given_month;
        if (!ym) return { min: "", max: "" };
        const [y, m] = ym.split("-").map(Number);
        const last = new Date(y, m, 0).getDate();
        const mm = String(m).padStart(2, "0");
        const dd = String(last).padStart(2, "0");
        return { min: `${y}-${mm}-01`, max: `${y}-${mm}-${dd}` };
    }, [editFormData.given_month]);

    const getWholesaleMasterData = async () => {
        try {
            const response = await redirectURL.post("masters/getWholesaleData", {});
            const data = response?.data?.data || [];
            setRowData(Array.isArray(data) ? data : []);
            setColumnWithDefs(wholesaleCols);
        } catch (err) {
            console.error("Error fetching wholesale data:", err);
            setRowData([]);
            setColumnWithDefs(wholesaleCols);
            setShow(true);
            setBasicType("error");
            setBasicTitle("Failed to fetch wholesale data");
        }
    };

    const getMainData = async () => {
        setLoadshow("show-m");
        setOverlayBlock("show-m");
        await getWholesaleMasterData();
        setLoadshow("show-n");
        setOverlayBlock("show-n");
    };

    useEffect(() => {
        getMainData();
    }, []);

    const onSaveWholesale = async () => {
        const { given_month, wholesale_date } = editFormData;
        if (!given_month || !wholesale_date) {
            setShow(true);
            setBasicType("warning");
            setBasicTitle("Please select Given Month and Wholesale Date.");
            return;
        }

        // Validate date range
        try {
            const [gy, gm] = given_month.split("-").map(Number);
            const d = new Date(wholesale_date);
            if (isNaN(d)) throw new Error("Invalid wholesale date");
            const sameMonth = (d.getUTCFullYear() === gy) && (d.getUTCMonth() + 1 === gm);
            if (!sameMonth) {
                setShow(true);
                setBasicType("warning");
                setBasicTitle("Wholesale Date must be within the selected Given Month.");
                return;
            }
        } catch {
            setShow(true); 
            setBasicType("warning"); 
            setBasicTitle("Invalid date selection.");
            return;
        }

        try {
            setLoadshow("show-m");
            setOverlayBlock("show-m");

            const payload = {
                given_month,
                wholesale_date,
            };

            const resp = await redirectURL.post("masters/addWholesaleDay", payload);

            if (resp?.data?.status === "success") {
                setShow(true); 
                setBasicType("success"); 
                setBasicTitle("Wholesale day saved successfully.");
                closeSlider();
                await getMainData();
            } else {
                setShow(true);
                setBasicType("warning");
                setBasicTitle(resp?.data?.message || "Save failed");
            }
        } catch (err) {
            console.error("Save wholesale error:", err);
            setShow(true);
            setBasicType("error");
            setBasicTitle(err?.response?.data?.message || "Save failed");
        } finally {
            setLoadshow("show-n");
            setOverlayBlock("show-n");
        }
    };

    const onUpdateWholesale = async () => {
        const { id, given_month, wholesale_date } = editFormData;
        
        if (!id) {
            setShow(true);
            setBasicType("error");
            setBasicTitle("Invalid record ID for update.");
            return;
        }

        if (!given_month || !wholesale_date) {
            setShow(true);
            setBasicType("warning");
            setBasicTitle("Please select Given Month and Wholesale Date.");
            return;
        }

        // Check if any changes were made
        const isNeedtoUpdate = Object.keys(duplicatedEditData).some(
            (key) => duplicatedEditData[key] !== editFormData[key]
        );

        if (!isNeedtoUpdate) {
            setShow(true);
            setBasicType("info");
            setBasicTitle("No changes made to wholesale data");
            return;
        }

        // Validate date range
        try {
            const [gy, gm] = given_month.split("-").map(Number);
            const d = new Date(wholesale_date);
            if (isNaN(d)) throw new Error("Invalid wholesale date");
            const sameMonth = (d.getUTCFullYear() === gy) && (d.getUTCMonth() + 1 === gm);
            if (!sameMonth) {
                setShow(true);
                setBasicType("warning");
                setBasicTitle("Wholesale Date must be within the selected Given Month.");
                return;
            }
        } catch {
            setShow(true); 
            setBasicType("warning"); 
            setBasicTitle("Invalid date selection.");
            return;
        }

        try {
            setLoadshow("show-m");
            setOverlayBlock("show-m");

            const payload = {
                id,
                given_month,
                wholesale_date,
            };

            const resp = await redirectURL.post("masters/updateWholesaleDay", payload);

            if (resp?.data?.status === "success") {
                setShow(true); 
                setBasicType("success"); 
                setBasicTitle("Wholesale day updated successfully.");
                closeSlider();
                await getMainData();
            } else {
                setShow(true);
                setBasicType("warning");
                setBasicTitle(resp?.data?.message || "Update failed");
            }
        } catch (err) {
            console.error("Update wholesale error:", err);
            setShow(true);
            setBasicType("error");
            setBasicTitle(err?.response?.data?.message || "Update failed");
        } finally {
            setLoadshow("show-n");
            setOverlayBlock("show-n");
        }
    };

    return (
        <>
            <div className="container-fluid mt-3">
                <div style={{ zIndex: "9999999" }}>
                    <SweetAlert
                        show={show}
                        type={basicType}
                        title={basicTitle}
                        onConfirm={closeAlert}
                        style={{ fontSize: "9px" }}
                    >
                    </SweetAlert>
                </div>

                <div className="col-sm-12 text-right pr-0 mb-4">
                    <button
                        onClick={openSlider}
                        style={{ 
                            backgroundColor: "#93385D", 
                            color: "#fff", 
                            border: "2px solid #93385D", 
                            marginRight: 15,
                            borderRadius: 5, 
                            padding: 6  
                        }}
                    >
                        <IoMdAdd style={{ color: "#fff", fontSize: "18px" }} />
                        {" Add"}
                    </button>
                </div>

                <div className="row" style={{ fontSize: "0.9rem", fontFamily: "Arial, sans-serif" }}>
                    <div className="col-sm-12 p-0 pl-2 mt-6">
                        <div className="ag-theme-alpine" style={{ height: 450, width: "100%" }}>
                            <AgGridReact
                                rowData={rowData}
                                columnDefs={columnWithDefs}
                                defaultColDef={defaultColDef}
                                domLayout="normal"
                                sideBar={sideBar}
                                statusBar={statusPanel}
                                pagination
                                paginationPageSize={100}
                                enableRangeSelection
                                gridOptions={{ suppressHorizontalScroll: false }}
                            />
                        </div>
                    </div>
                </div>
            </div>

            {/* Slider for Add/Edit */}
            <div
                className={`stock-status-slider ${isSliderOpen ? "open" : ""} ${sliderCl}`}
                style={{ width: "25%" }}
            >
                <div className="slider-header-container d-flex justify-content-between">
                    <p className="m-0p">{sliderTitle}</p>
                    <p
                        className="m-0p"
                        style={{ cursor: "pointer" }}
                        onClick={onClickingSliderCloseIcon}
                    >
                        X&nbsp;&nbsp;&nbsp;
                    </p>
                </div>

                {(sliderType === 1 || sliderType === 2) && (
                    <div className="panel-body" style={{ padding: "16px 20px", flex: 1, overflowY: "auto" }}>
                        <div className="form-field" style={{ marginBottom: 16 }}>
                            <label style={{ display: "block", fontWeight: 600, marginBottom: 6 }}>
                                Calendar Month <span style={{ color: "red" }}>*</span>
                            </label>
                            <input
                                type="month"
                                id="wholesaleMonth"
                                value={editFormData.given_month}
                                onChange={(e) => setEditFormData({ ...editFormData, given_month: e.target.value, wholesale_date: "" })}
                                style={{ width: "100%", height: 44, border: "1px solid #e5e7eb", borderRadius: 8, padding: "0 12px" }}
                                min={currentMonth}
                                onClick={() => document.getElementById('wholesaleMonth').showPicker?.()}
                                disabled={sliderType === 2} // Disable for edit mode
                            />
                        </div>

                        <div className="form-field" style={{ marginBottom: 16 }}>
                            <label style={{ display: "block", fontWeight: 600, marginBottom: 6 }}>
                                Wholesale Date <span style={{ color: "red" }}>*</span>
                            </label>
                            <input
                                type="date"
                                id="wholesaleDate"
                                value={editFormData.wholesale_date}
                                onChange={(e) => setEditFormData({ ...editFormData, wholesale_date: e.target.value })}
                                min={monthBounds.min}
                                max={monthBounds.max}
                                style={{ width: "100%", height: 44, border: "1px solid #e5e7eb", borderRadius: 8, padding: "0 12px" }}
                                disabled={!editFormData.given_month}
                                onClick={() => document.getElementById('wholesaleDate').showPicker?.()}
                            />
                        </div>

                        <div style={{ display: "flex", justifyContent: "flex-end", marginTop: 16 }}>
                            <button
                                onClick={sliderType === 1 ? onSaveWholesale : onUpdateWholesale}
                                style={{
                                    padding: "10px 18px",
                                    border: 0,
                                    borderRadius: 8,
                                    cursor: "pointer",
                                    fontWeight: 700,
                                    color: "#fff",
                                    background: "#8a2d45",
                                }}
                            >
                                {sliderType === 1 ? "ADD" : "UPDATE"}
                            </button>
                        </div>
                    </div>
                )}            
            </div>

            {showDeletePopup && (
                <div
                    className="d-flex justify-content-center align-items-center"
                    style={{
                        position: "fixed",
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%, -50%)",
                        zIndex: "1003",
                        backgroundColor: "rgba(255, 255, 255, 0.9)",
                        padding: "20px",
                        borderRadius: "10px",
                    }}
                >
                    <div className="inventory-delete-popup">
                        <p
                            style={{
                                color: "grey",
                                fontSize: "19px",
                                textAlign: "center",
                                fontWeight: "bold",
                                marginBottom: "20px",
                            }}
                        >
                            {`Do you want to remove this wholesale day on ${
                                selectedRow
                                    ? new Date(selectedRow.wholesale_date)
                                        .toISOString()
                                        .split("T")[0]
                                    : ""
                            }?`}
                        </p>
                        <div className="d-flex justify-content-center align-items-center">
                            <button
                                className="btn btn-danger"
                                onClick={onClickingPopupDeleteBtn}
                                style={{ marginRight: "10px" }}
                            >
                                Delete
                            </button>
                            <button
                                className="btn btn-secondary"
                                onClick={onClickDeletePopupCancelBtn}
                            >
                                Cancel
                            </button>
                        </div>
                    </div>
                </div>
            )}

            <div className={`loader ${loadshow}`} style={{ zIndex: "1002" }}></div>
<div style={{ zIndex: 997 }} className={`overlay-block ${overlayBlock}`}></div>
            <div
                className={"overly-block " + overlyBlock}
                onClick={hideOverlySlideBlock}
            ></div>
        </>
    );
};

export default WholesaleMaster;